import s from "./payment-card.module.scss";
import classNames from "classnames";
import { IconCreditCard, IconTrash } from "@tabler/icons-react";
import { Button } from "@shared/ui/button/button";
import { useAddCard } from "@entities/profile/api/useAddCard";
import { useRemoveCard } from "@entities/profile/api/useRemoveCard";
import { getPaymentSystem } from "@utils/lib/getPaymentSystem";

const formatCardNumber = (masked) =>
	masked
		?.replace(/\s/g, "")
		.replace(/(.{4})/g, "$1 ")
		.trim() || ""

export const PaymentCard = ({ profile }) => {
	const { mutateAsync: addCard } = useAddCard();
	const { mutate: removeCard } = useRemoveCard();

	const handleAddCard = () => {
		addCard().then((res) => {
			window.open(res.data, "_self");
		});
	};

	const paymentSystem = getPaymentSystem(profile?.card_num_masked);
	const cardNumber = formatCardNumber(profile?.card_num_masked);

	return (
		<div className={s.paymentCard}>
			{profile?.card_num_masked ? (
				<div className={s.cardAttached}>
					<div className={s.cardTop}>
						<div className={classNames(s.cardBadge, s[paymentSystem.className])}>
							<IconCreditCard size={18} />
							<span>{paymentSystem.name}</span>
						</div>
						<button
							type="button"
							className={s.removeBtn}
							onClick={removeCard}
							aria-label="Удалить карту"
						>
							<IconTrash size={16} />
							<span>Удалить</span>
						</button>
					</div>
					<div className={s.cardNumber}>{cardNumber}</div>
					<p className={s.cardHint}>
						На эту карту будут приходить деньги за проведенные занятия
					</p>
				</div>
			) : (
				<div className={s.cardEmpty}>
					<div className={s.cardEmptyIcon}>
						<IconCreditCard size={32} />
					</div>
					<p className={s.cardEmptyTitle}>Карта не привязана</p>
					<p className={s.cardEmptyHint}>
						Чтобы появиться в поиске и начать преподавать платные занятия,
						необходимо привязать карту для выплат. Мы не храним и не передаем
						данные вашей карты.
					</p>
					<Button
						onClick={handleAddCard}
						lefticon={<IconCreditCard size={20} />}
						label="Привязать карту"
						size="small"
					/>
				</div>
			)}
		</div>
	);
};
